"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiatForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useContextSelector = require("use-context-selector");
var _reactstrap = require("reactstrap");
var _ui = require("../../../../ui");
var _fields = require("../../../../fields");
var _TickerGroup = require("./TickerGroup");
var _BalanceGroup = require("./BalanceGroup");
var _hooks = require("../../../../../hooks");
var _page = require("../page");
var _providers = require("../providers");
var _confirmModal = require("../confirm-modal");
var _form = require("../../form");
var _Footer = require("./Footer");
var _state = require("../../../../../state");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputCurrencyText = (0, _styledComponents.default)(_ui.MediumSpan)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var FiatForm = function FiatForm(_ref2) {
  var _balance$value, _balance$converted;
  var children = _ref2.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var onFormSubmit = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.onFormSubmit;
  });
  var ticker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.ticker;
  });
  var tickers = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.tickers;
  });
  var convertedTicker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.convertedTicker;
  });
  var setInfo = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.setInfo;
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    amountInputFocused = _useState2[0],
    setAmountInputFocused = _useState2[1];
  var _useContext = (0, _react.useContext)(_providers.CreateWithdrawContext),
    useCreateWithdraw = _useContext.useCreateWithdraw;
  var _useCreateWithdraw = useCreateWithdraw(),
    withdrawState = _useCreateWithdraw.withdrawState;
  var _useContext2 = (0, _react.useContext)(_providers.BalanceContext),
    useBalances = _useContext2.useBalances,
    balanceName = _useContext2.balanceName;
  var _useBalances = useBalances(),
    getBalanceByTicker = _useBalances.getBalanceByTicker,
    balances = _useBalances.balances;
  var balance = getBalanceByTicker(ticker);
  var price = (0, _state.usePrice)({
    ticker: ticker,
    convertedTicker: convertedTicker
  });
  var _useSendFiatForm = (0, _hooks.useSendFiatForm)({
      withdrawDone: withdrawState.done
    }),
    formProviderProps = _useSendFiatForm.formProviderProps,
    isFormValid = _useSendFiatForm.isFormValid;
  var _useFiatSendFee = (0, _hooks.useFiatSendFee)({
      isFormValid: isFormValid
    }),
    value = _useFiatSendFee.value;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: formProviderProps.handleSubmit(onFormSubmit)
  }, children, /*#__PURE__*/_react.default.createElement(_TickerGroup.TickerGroup, {
    ticker: ticker,
    tickers: tickers,
    balances: balances,
    onTickerChange: function onTickerChange(ticker) {
      return setInfo({
        ticker: ticker
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_BalanceGroup.BalanceGroup, {
    balanceName: balanceName,
    ticker: ticker,
    convertedTicker: convertedTicker,
    balance: (_balance$value = balance === null || balance === void 0 ? void 0 : balance.value) !== null && _balance$value !== void 0 ? _balance$value : '0',
    convertedBalance: (_balance$converted = balance === null || balance === void 0 ? void 0 : balance.converted) !== null && _balance$converted !== void 0 ? _balance$converted : '0'
  }), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('destinationCard')), /*#__PURE__*/_react.default.createElement(_fields.CardNumberInputField, {
    control: formProviderProps.control,
    inputProps: {
      name: 'card'
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('amount')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/_react.default.createElement(InputCurrencyText, null, ticker)), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: formProviderProps.control,
    debounce: 500,
    inputProps: {
      name: 'amount',
      ticker: ticker,
      decimals: 0,
      onFocus: function onFocus() {
        return setAmountInputFocused(true);
      },
      onBlur: function onBlur() {
        return setAmountInputFocused(false);
      },
      onChange: function onChange() {
        if (amountInputFocused) formProviderProps.trigger('amount');
      }
    }
  })), price.value && /*#__PURE__*/_react.default.createElement(_form.Rate, {
    ticker: ticker,
    convertedTicker: convertedTicker,
    price: price.value
  })), /*#__PURE__*/_react.default.createElement(_Footer.Footer, {
    disabled: !value,
    fiat: true
  }), /*#__PURE__*/_react.default.createElement(_confirmModal.FiatConfirmModal, null));
};
exports.FiatForm = FiatForm;